<div class="profile-container">

  <!-- SECCIÓN 1: Datos del usuario -->
  <mat-card class="user-card">
    <div class="user-header">
      <div class="user-avatar">{{ userInitials }}</div>
      <div class="user-info">
        <h2 class="user-email">{{ email }}</h2>
        <p class="user-id">ID: {{ userId }}</p>
      </div>
      <div class="user-sub">
        <span class="dias-chip" [ngClass]="getChipClassDias()">
          <mat-icon>schedule</mat-icon>
          {{ diasRestantes }} días restantes
        </span>
      </div>
    </div>
  </mat-card>

  <!-- SECCIÓN 2: Mis Carteras -->
  <section class="section">
    <h3 class="section-title">
      <mat-icon>account_balance_wallet</mat-icon>
      Mis Carteras
    </h3>
    <div *ngIf="loadingCarteras" class="loading-area">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
    <ng-container *ngIf="!loadingCarteras">
      <p *ngIf="carteras.length === 0" class="empty-msg">No hay carteras registradas.</p>
      <div class="carteras-grid" *ngIf="carteras.length > 0">
        <mat-card *ngFor="let cartera of carteras" class="cartera-card">
          <div class="cartera-card-header">
            <span class="cartera-nombre">{{ cartera.nombre }}</span>
            <span class="broker-chip" [ngClass]="'chip-broker-' + getTipoBrokerLabel(cartera).toLowerCase()">
              {{ getTipoBrokerLabel(cartera) }}
            </span>
          </div>
          <mat-divider></mat-divider>
          <div class="cartera-metrics">
            <div class="cartera-metric">
              <span class="metric-label">Capital inicial</span>
              <span class="metric-value">{{ cartera.capitalinicial | number:'1.0-0' }} €</span>
            </div>
            <div class="cartera-metric">
              <span class="metric-label">Valor liquidativo</span>
              <span class="metric-value">{{ cartera.valorLiquidativo | number:'1.0-2' }} €</span>
            </div>
            <div class="cartera-metric">
              <span class="metric-label">Rendimiento neto</span>
              <span class="metric-value rendimiento" [ngClass]="cartera.rendimientoNeto >= 0 ? 'pos' : 'neg'">
                {{ cartera.rendimientoNeto >= 0 ? '+' : '' }}{{ cartera.rendimientoNeto | number:'1.2-2' }}%
              </span>
            </div>
          </div>
        </mat-card>
      </div>
    </ng-container>
  </section>

  <!-- SECCIÓN 3: Conexión Broker IBKR -->
  <section class="section">
    <h3 class="section-title">
      <mat-icon>link</mat-icon>
      Broker IBKR
    </h3>
    <mat-card class="broker-card">
      <div class="broker-status-row">
        <div class="status-item">
          <span class="status-label">Conexión</span>
          <span class="estado-badge" [ngClass]="ibkrConectado ? 'estado-conectado' : 'estado-desconectado'">
            {{ ibkrConectado ? 'Conectado' : 'Desconectado' }}
          </span>
        </div>
        <div class="status-item">
          <span class="status-label">API disponible</span>
          <span class="estado-badge" [ngClass]="ibkrApiDisponible ? 'estado-conectado' : 'estado-desconectado'">
            {{ ibkrApiDisponible ? 'Sí' : 'No' }}
          </span>
        </div>
        <button mat-stroked-button color="primary" class="broker-btn" (click)="irABroker()">
          <mat-icon>open_in_new</mat-icon>
          Ir a Broker
        </button>
      </div>
    </mat-card>
  </section>

  <!-- SECCIÓN 4: Cuentas MetaAPI -->
  <section class="section">
    <h3 class="section-title">
      <mat-icon>swap_horiz</mat-icon>
      Cuentas MetaAPI
    </h3>
    <div *ngIf="loadingMetaApi" class="loading-area">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
    <ng-container *ngIf="!loadingMetaApi">
      <p *ngIf="metaApiCuentas.length === 0" class="empty-msg">No hay cuentas MetaAPI registradas.</p>
      <div class="metaapi-grid" *ngIf="metaApiCuentas.length > 0">
        <mat-card
          *ngFor="let cuenta of metaApiCuentas"
          class="metaapi-card"
          [class.cuenta-activa]="cuenta.metaApiAccountId === activeMetaApiAccountId">
          <div class="metaapi-card-header">
            <span class="metaapi-nombre">{{ cuenta.nombre || cuenta.mtLogin }}</span>
            <span class="estado-badge"
              [ngClass]="'estado-' + (cuenta.estado || 'undeployed').toLowerCase().replace('_', '')">
              {{ cuenta.estado || 'undeployed' }}
            </span>
          </div>
          <mat-divider></mat-divider>
          <div class="metaapi-info">
            <div class="metaapi-info-row">
              <mat-icon class="info-icon">person</mat-icon>
              <span>Login: <strong>{{ cuenta.mtLogin }}</strong></span>
            </div>
            <div class="metaapi-info-row">
              <mat-icon class="info-icon">dns</mat-icon>
              <span>Servidor: <strong>{{ cuenta.mtServer }}</strong></span>
            </div>
            <div class="metaapi-info-row">
              <mat-icon class="info-icon">public</mat-icon>
              <span>Región: <strong>{{ cuenta.region }}</strong></span>
            </div>
            <div class="metaapi-info-row">
              <mat-icon class="info-icon">tag</mat-icon>
              <span class="account-id-mono">{{ cuenta.metaApiAccountId }}</span>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="metaapi-card-actions">
            <button mat-button color="primary"
              *ngIf="cuenta.metaApiAccountId !== activeMetaApiAccountId"
              (click)="activarCuentaMetaApi(cuenta)">
              <mat-icon>check_circle_outline</mat-icon> Usar esta cuenta
            </button>
            <span class="cuenta-activa-label" *ngIf="cuenta.metaApiAccountId === activeMetaApiAccountId">
              <mat-icon>check_circle</mat-icon> Cuenta activa
            </span>
          </div>
        </mat-card>
      </div>
    </ng-container>
  </section>

</div>
